import $foreign from "./foreign.cjs";
var empty = $foreign.empty;
var iterate = $foreign.iterate;
var length = $foreign.length;
var push = $foreign.push;
var remove = $foreign.remove;
export { empty, iterate, length, push, remove };
